import { useIsSignedIn } from "PFApp/hooks";
import { useCurrentAccount } from "PFCore/hooks/queries/account/use_current_account";
import { ApiRoute, UiRoute } from "PFCore/utilities/routes";
import { useEffect } from "react";
import { Navigate } from "react-router";

const SamlSignInPage = () => {
  const { data: currentAccount } = useCurrentAccount();
  const { isSignedIn } = useIsSignedIn();

  useEffect(() => {
    if (!isSignedIn) {
      const authorizeParams = new URLSearchParams({
        account: currentAccount.full_domain,
        client_id: window.PF.config.client_id || "",
        grant_type: "saml",
        redirect_uri: UiRoute("/")
      });
      window.location.href = ApiRoute(`/api/oauth/authorize?${authorizeParams.toString()}`);
    }
  }, [isSignedIn, currentAccount.full_domain]);

  if (isSignedIn) {
    return <Navigate to="/" replace />;
  }

  return null;
};

export default SamlSignInPage;
